export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-10.png?9db3e4ecb6562148d7b43618a8e64f42";